import { render } from "./adminHomeView.vue?vue&type=template&id=78482552"
import script from "./adminHomeView.vue?vue&type=script&lang=js"
export * from "./adminHomeView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__